import React from 'react'
import styled from 'styled-components'

import StatusLabel from 'components/Luxkit/Label/StatusLabel'

const StatusLabelWithPrintBorder = styled(StatusLabel)`
  @media print {
    &.kind-tertiary {
      border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
    }
  }
`

function BookedLabel() {
  return (
    <StatusLabelWithPrintBorder variant="confirmation">
      Booked
    </StatusLabelWithPrintBorder>
  )
}

export default React.memo(BookedLabel)
